import { Breadcrumb, Space } from "antd";
import { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Excel from "src/components/Excel";
import Information from "src/components/Information";
import Pdf from "src/components/Pdf/pdf";
import { MapMasterdataBreadcrumb } from "src/entity/common/masterdata-map-bread";
import { MenuExportExcel } from "src/entity/excel/excel.entity";
import { MenuUploadVocResult, MenuUploadVocSeries } from "src/entity/fugitive/fugitive.constants";
import { blacklistViewInformation } from "src/entity/information/information.entity";
import { MenuExportPdf } from "src/entity/pdf/pdf.entity";
import { Permission } from "src/entity/permission/permission";
import { MenuEditProduction } from "src/entity/production/production.entity";
import useNavigationMenu from "src/hook/useNavigationMenu";
import EditProduction from "src/pages/Production/components/EditProduction";
import { profileStore } from "src/stores/profile-store";
import UploadReportVocSeries from "src/pages/VocsInventory/Fugitive/ReportVocSeries/components/UploadReportVocSeries";
import UploadVocResult from "src/pages/VocsInventory/Fugitive/VocResult/components/UploadVocResult";
import { utilsStore } from "src/stores/utils-store";
import { menuPalette } from "src/theme/menu-shade";
import { getBreadcrumbCapitalize } from "src/utils/get-menus";
import { capitalizeFirstLetter } from "src/utils/manage-string";
import { useShallow } from "zustand/react/shallow";

const blacklist = [
  "setup",
  "manual",
  "report",
  // "history",
  "combustion",
  "flare",
  "transportation-and-marketing",
  "tank",
  "waste-water-treatment",
  "information",
  "others",
  "fugitive",
];
const actionPathList = ["setup-", "report-", "manual-", "history", "information-"];
const black_txt = { color: menuPalette.textMenuActive };

const Breadcrumbs = () => {
  const location = useLocation();
  const { pathname } = location;
  const activeMasterdata = utilsStore(useShallow((state) => state.activeMasterdata));
  const { permissions } = useNavigationMenu();
  const profile = profileStore(useShallow((state) => state.profile));

  const checkPermissionExcel = [Permission.V, Permission.VO, Permission.EA, Permission.EO, Permission.A].some((permission) =>
    permissions?.includes(permission),
  );

  const specialCustomLinkPath = (str: string) => {
    // console.log("STR : ", str);
    const specificPath: Record<string, string> = {
      [`/vocs-inventory/waste-water-treatment/setup-information@Information`]: "WW Information",
      [`/vocs-inventory/waste-water-treatment/manual-voc-water@VOCs Water`]: "VOCs Water 9",
      [`/vocs-inventory/tank/manual-voc-tank@VOC Tank`]: "VOCs Tank 4.0",
      [`/vocs-inventory/others/information@`]: "Information",
      [`voc`]: "VOCs",
    };
    if (specificPath[`${pathname}@${str}`]) {
      return specificPath[`${pathname}@${str}`];
    } else return str;
  };

  const breadcrumbItems = useMemo(() => {
    const splitPaths = pathname.slice(1).split("/").filter(Boolean);
    const items = [
      {
        title: (
          <Link style={black_txt} to={"/"}>
            HOME
          </Link>
        ),
      },
    ];
    let path = "";
    // console.log("details path : ", { splitPaths, pathname });
    splitPaths.forEach((item) => {
      // console.log("Bread Item : ", item);
      path += `/${item}`;
      if (blacklist.includes(item.toLowerCase()))
        items.push({
          title: <span style={black_txt}>{getBreadcrumbCapitalize(item, pathname)}</span>,
        });
      else {
        // Add Setup, Manual, Report, History to Breadcrumb
        const findActionMatchPath = actionPathList.find((e) => item.includes(e));
        if (findActionMatchPath && path !== "/setting/history" && path !== "/vocs-inventory/others/history") {
          items.push({
            title: <span style={black_txt}>{capitalizeFirstLetter(findActionMatchPath.replace("-", ""))}</span>,
          });
        }
        const customLinkPath = getBreadcrumbCapitalize(item);
        // console.log("customLinkPath : ", customLinkPath);
        items.push({
          title: (
            <Link style={black_txt} to={path}>
              {specialCustomLinkPath(customLinkPath)}
            </Link>
          ),
        });
      }
    });

    // Add active tab to Breadcrumb
    if (pathname.includes("setting/masterdata")) {
      items.push({
        title: <span style={black_txt}>{MapMasterdataBreadcrumb[`${activeMasterdata}`]}</span>,
      });
    }
    return items;
  }, [pathname, activeMasterdata]);

  // console.log("MapMasterdataBreadcrumb[`${activeMasterdata}`] : ", MapMasterdataBreadcrumb[`${activeMasterdata}`]);
  if (!pathname || pathname === "/") return <Breadcrumb></Breadcrumb>;
  else
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Breadcrumb style={{ padding: "1.5% 0 0 2%" }} items={breadcrumbItems}></Breadcrumb>
        {/* {pathname} */}
        {/* Render Information ICON */}
        {!blacklistViewInformation.includes(pathname) && (
          <div style={{ padding: "1.5% 1.5% 0 2%" }}>
            <Space>
              {MenuUploadVocResult.includes(pathname) && (
                <div style={{ padding: "1.5% 1.5% 0 0%" }}>
                  <UploadVocResult />
                </div>
              )}
              {MenuUploadVocSeries.includes(pathname) && (
                <div style={{ padding: "1.5% 1.5% 0 0%" }}>
                  <UploadReportVocSeries />
                </div>
              )}
              {profile?.isSystemAdmin && MenuEditProduction.includes(pathname) && <EditProduction />}
              {MenuExportExcel.includes(pathname) && checkPermissionExcel && (
                <div style={{ padding: "1.5% 1.5% 0 0%" }}>
                  <Excel path={pathname} />
                </div>
              )}
              {MenuExportPdf.includes(pathname) && checkPermissionExcel && (
                <div style={{ padding: "1.5% 1.5% 0 0%" }}>
                  <Pdf path={pathname} />
                </div>
              )}
              <Information path={pathname} />
            </Space>
          </div>
        )}
        {/* Render Information ICON */}
      </div>
    );
};

export default Breadcrumbs;
